<div class="overtime-rates-container" [formGroup]="overtimeRatesForm">
    <div class="row mb-3">
        <label>
            {{ 'PROPERTIES_OVERTIME_RATES_LABEL' | translate }}
        </label>
    </div>
    <fieldset>
        <legend>{{ 'PROPERTIES_OVERTIME_RATES_SALES_OFFICE' | translate }}</legend>
         <div class="container-padding">
        <div class="row col-sm-4 "> 
            <mat-form-field appearance="outline">
                <mat-select formControlName="salesOffice">
                    <mat-option *ngFor="let office of salesOffices; trackBy: trackById" [value]="office.id">
                        {{ office.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row col-sm-4">
            <mat-checkbox color="primary" class="override-checkbox" formControlName="overrideCalculation">
                {{ 'PROPERTIES_OVERTIME_RATES_OVERRIDE_CALCULATION' | translate }}
            </mat-checkbox>
        </div>
        </div>
        <table mat-table [dataSource]="overtimeRates" class="table-container">
            <ng-container matColumnDef="labor">
                <th mat-header-cell *matHeaderCellDef> {{ 'PROPERTIES_OVERTIME_RATES_LABOR' | translate }} </th>
                <td mat-cell *matCellDef="let rowGroup"> {{rowGroup.controls.labor.value}} </td>
            </ng-container>
            <ng-container matColumnDef="base">
                <th mat-header-cell *matHeaderCellDef> {{ 'PROPERTIES_OVERTIME_RATES_BASE' | translate }} </th>
                <td mat-cell *matCellDef="let rowGroup"> {{rowGroup.controls.base.value | multilingualCurrency}} </td>
            </ng-container>
            <ng-container matColumnDef="oneDotOneX">
                <th mat-header-cell *matHeaderCellDef> {{ 'PROPERTIES_OVERTIME_RATES_ONE_DOT_ONE_X' | translate }} </th>
                <td mat-cell *matCellDef="let rowGroup; let i= index" [formGroup]="rowGroup">
                    <span *ngIf="!canEditOvertimeRates; else editOneDotOneX">{{rowGroup.controls.oneDotOneX.value |
                        multilingualCurrency}}</span>
                    <ng-template #editOneDotOneX>
                        <mat-form-field appearance="outline">
                            <input matInput [appNumericMask]="otRatesNumericFieldsConfig" class="text-end" formControlName="oneDotOneX" (blur)=" onRateChange(i, 'oneDotOneX')"/>
                        </mat-form-field>
                    </ng-template>
                </td>
            </ng-container>
            <ng-container matColumnDef="oneDotFiveX">
                <th mat-header-cell *matHeaderCellDef> {{ 'PROPERTIES_OVERTIME_RATES_ONE_DOT_FIVE_X' | translate }}
                </th>
                <td mat-cell *matCellDef="let rowGroup; let i= index" [formGroup]="rowGroup">
                    <span *ngIf="!canEditOvertimeRates; else editOneDotFiveX">{{rowGroup.controls.oneDotFiveX.value |
                        multilingualCurrency}}</span>
                    <ng-template #editOneDotFiveX>
                        <mat-form-field appearance="outline" >
                            <input matInput [appNumericMask]="otRatesNumericFieldsConfig" class="text-end"  formControlName="oneDotFiveX" (blur)=" onRateChange(i, 'oneDotFiveX')"/>
                        </mat-form-field>
                    </ng-template>
                </td>
            </ng-container>
            <ng-container matColumnDef="twoX">
                <th mat-header-cell *matHeaderCellDef> {{ 'PROPERTIES_OVERTIME_RATES_TWO_X' | translate }} </th>
                <td mat-cell *matCellDef="let rowGroup; let i= index" [formGroup]="rowGroup">
                    <span *ngIf="!canEditOvertimeRates; else editTwoX">{{rowGroup.controls.twoX.value |
                        multilingualCurrency}}</span>
                    <ng-template #editTwoX>
                        <mat-form-field appearance="outline">
                            <input matInput [appNumericMask]="otRatesNumericFieldsConfig" class="text-end"  formControlName="twoX" (blur)=" onRateChange(i, 'twoX')"/>
                        </mat-form-field>
                    </ng-template>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="row-height"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height"></tr>
        </table>
        
    </fieldset>
</div>